import { render, staticRenderFns } from "./CreateSupplierForm.vue?vue&type=template&id=08e6b693"
import script from "./CreateSupplierForm.vue?vue&type=script&lang=js"
export * from "./CreateSupplierForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports